import React, { useState, useEffect, createContext, useContext  } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import '../../../css/form.css';
import axios from "axios";
import { API } from "../../../services/api";
import { UserContext } from "../../../App";

axios.defaults.baseURL = API;

function CancelTrasactionBill() {

  const {userID, LocationID, UserName, LocationName} = useContext(UserContext);
  const [showData, setShowData] = useState([]);

  async function HandleCancelBill (TransactionServiceID) {
    let token = localStorage.getItem("token");
    await axios.put(`/CancelTransactionServiceBill/${TransactionServiceID}/${userID}`, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
      getMemberIDFromTransaction(TransactionServiceID);  
        ClearData();
    }).catch((err) => {
        console.log(err);
    });
  }

  async function getMemberIDFromTransaction (TransactionServiceID) {
    await axios.get(`/getMemberIDFromTransactionService/${TransactionServiceID}`).then((response) => {
      let Data = response?.data;
      if(Data.length > 0){
        if(Data[0].MemberID){
          var pAmout = 0;
          if(Data[0].PaidMoreAmount > 0){
            pAmout = Number(Data[0].NetTotal) - Number(Data[0].PaidMoreAmount);
            getMemberByMemberID( Data[0].MemberID, pAmout);
          } else {
            getMemberByMemberID( Data[0].MemberID, Data[0].NetTotal);
          }
        } 
      } 
    }).catch((error) => {
      console.log(error);
    });
  }

  async function getMemberByMemberID(MemberID, NetTotal) {
    let token = localStorage.getItem("token");
    await axios.get(`/getMemberByMemberID/${MemberID}`, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
        let memberData = response?.data;
        if(memberData.length > 0){
            UpdateMember(MemberID, Number(memberData[0].Amount), Number(NetTotal));
        } 
    }).catch((err) => {
        console.log(err);
    });
};

async function UpdateMember(MemberID, amount, NetTotal) {
  let token = localStorage.getItem("token");
  var data = {
      MemberID: MemberID,
      Amount: Number(amount) + Number(NetTotal),
  }
  console.log(data);
  await axios.post("/usememberforcancleTransactionService", data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
  }).catch((err) => {
      console.log(err);
  });
};

  
  const ClearData = () => {
    setShowData([]);
  }

  async function SearchTransaction(e) {
    const { value } = e.target;
    if(value){
      await axios.get(`/SearchTransactionService/${value}`).then((response) => {
        let Data = response?.data;
        setShowData(Data);
      }).catch((error) => {
        console.log(error);
      });
    } else {
      setShowData([]);
    }
  };

  return (
      <div className="formContent">
        <div className="Header">
          <div className="title">
              <span>ຍົກເລີກບິນ</span>
          </div>
          <div className="txtSearch">
            <input placeholder="ຄົ້ນຫາເລກບິນ" onChange={(e) => SearchTransaction(e)} />
          </div>
        </div>
        <div className="Body">
          <table className="styled-table">
            <thead>
              <tr key={1}>
                <th>ລ/ດ</th>
                <th>ເລກບິນ</th>
                <th>ຍອດລວມ</th>
                <th>ສ່ວນຫລຸດ</th>
                <th>ຍອດທີ່ຕ້ອງຈ່າຍ</th>
                <th>ຍອດຈ່າຍ</th>
                <th>ຈ່າຍເພີ່ມ</th>
                <th>ປະເພດຈ່າຍ</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {
                showData && showData.map((x, y) => {
                    return (
                      <tr key={y}>
                        <td >{y + 1}</td>
                        <td >{x.TransactionServiceID}</td>
                        <td >{x.SubTotal}</td>
                        <td >{x.Discount}</td>
                        <td >{x.NetTotal}</td>
                        <td >{x.PaidAmount}</td>
                        <td >{x.PaidMoreAmount}</td>
                        <td >{x.PaymentType}</td>
                        <td >
                          <button className="btn btn-danger" value={x.TransactionServiceID} type="button" onClick={() => HandleCancelBill(x.TransactionServiceID,)}>ຍົກເລີກບິນ</button>
                        </td>
                      </tr>
                    )
                })
              }
            </tbody>
          </table>
        </div>
      </div>
  );
};

export default CancelTrasactionBill;
